var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18446_39528",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18446_39528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 13.3333C2.29967 13.3333 1.98579 13.2027 1.72467 12.9416C1.46356 12.6805 1.33301 12.3666 1.33301 12V3.99996C1.33301 3.63329 1.46356 3.3194 1.72467 3.05829C1.98579 2.79718 2.29967 2.66663 2.66634 2.66663H13.333C13.6997 2.66663 14.0136 2.79718 14.2747 3.05829C14.5358 3.3194 14.6663 3.63329 14.6663 3.99996V12C14.6663 12.3666 14.5358 12.6805 14.2747 12.9416C14.0136 13.2027 13.6997 13.3333 13.333 13.3333H2.66634ZM13.333 5.33329L8.34968 8.44996C8.29412 8.48329 8.23579 8.50829 8.17467 8.52496C8.11356 8.54163 8.05523 8.54996 7.99967 8.54996C7.94412 8.54996 7.88579 8.54163 7.82467 8.52496C7.76356 8.50829 7.70523 8.48329 7.64967 8.44996L2.66634 5.33329V12H13.333V5.33329ZM7.99967 7.33329L13.333 3.99996H2.66634L7.99967 7.33329ZM2.66634 5.49996V4.51663V4.53329V4.52496V5.49996Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.5f80545c95b52d6be5f38ecfcfe6397b.svg";
export { ForwardRef as ReactComponent };